import { defineMessages } from 'react-intl';
import { times } from 'lodash';

const imagesPath = './img';

export const sidebar = [
  {
    id: 'skills',
    messages: defineMessages({
      title: {
        id: 'profile.skills.title',
        defaultMessage: 'Skills',
      },
    }),
    image: require(`${imagesPath}/red-square.svg`),
  },
  {
    id: 'evaluations',
    messages: defineMessages({
      title: {
        id: 'profile.evaluation.title',
        defaultMessage: 'Evaluations',
      },
    }),
    image: require(`${imagesPath}/blue-triangle.svg`),
  },
  {
    id: 'workExperience',
    messages: defineMessages({
      title: {
        id: 'profile.work-exp.title',
        defaultMessage: 'Work',
      },
    }),
    image: require(`${imagesPath}/yellow-circle.svg`),
  },
  {
    id: 'education',
    messages: defineMessages({
      title: {
        id: 'profile.education.title',
        defaultMessage: 'Education',
      },
    }),
    image: require(`${imagesPath}/green-quarter-circle.svg`),
  },
];

export const defaultHeaderImages = times(5, i =>
  require(`${imagesPath}/header/cover_photo_${i + 1}.png`)
);
